module.exports = __webpack_public_path__ + "static/media/tops.89b6f10f.webp";